import { createAction } from "@reduxjs/toolkit";

const actionTypes = {
  getMemberships: createAction("getMemberships"),
  getSuscriptions: createAction("getSuscriptions"),
  getSuscription: createAction("getSuscription"),
};

export default actionTypes;
